import { render, staticRenderFns } from "./ParsingSentencePartsSpeechForm.vue?vue&type=template&id=8c9e31b2&scoped=true&lang=pug&"
import script from "./ParsingSentencePartsSpeechForm.vue?vue&type=script&lang=js&"
export * from "./ParsingSentencePartsSpeechForm.vue?vue&type=script&lang=js&"
import style0 from "./ParsingSentencePartsSpeechForm.vue?vue&type=style&index=0&id=8c9e31b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9e31b2",
  null
  
)

export default component.exports